import { useEffect, useState } from "react";
import { motion, AnimatePresence, useScroll, useSpring } from "framer-motion";
import { EASE } from "./motion";

export const INTRO_DELAY = 1.3;

export const Intro = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1300);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="intro-loader" className="fixed inset-0 z-[80] bg-[#07080B] grid place-items-center"
          exit={{ clipPath: "inset(0 0 100% 0)" }} initial={{ clipPath: "inset(0 0 0% 0)" }} transition={{ duration: 0.9, ease: EASE }}>
          <div className="flex flex-col items-center">
            <motion.img src="/velocity-badge.png" alt="Velocity Detailing" className="w-40 md:w-52"
              initial={{ scale: 0.7, opacity: 0, rotate: -12 }} animate={{ scale: 1, opacity: 1, rotate: 0 }} transition={{ duration: 0.9, ease: EASE }} />
            <div className="mt-8 h-px w-48 bg-white/10 overflow-hidden">
              <motion.div className="h-full bg-[#1bb4f2] origin-left" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 1.1, ease: EASE }} />
            </div>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.35em] text-slate-400">Gloss boss on wheels</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const x = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });
  return <motion.div style={{ scaleX: x }} className="fixed top-0 left-0 right-0 h-[2px] bg-[#1bb4f2] origin-left z-[60]" data-testid="scroll-progress" />;
};
